import { render, staticRenderFns } from "./VehicleRequestDatail.vue?vue&type=template&id=3c3e1a06&"
import script from "./VehicleRequestDatail.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestDatail.vue?vue&type=script&lang=js&"
import style0 from "./VehicleRequestDatail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VBtn,VCard,VDialog,VDivider,VIcon,VLayout,VProgressCircular,VRating})
